import CountUp from 'react-countup'
import React, { useEffect, useState, useRef } from "react"
import ReactDOM from 'react-dom'

export default function WidgetExample(props) {
  const sceneRef = useRef(null)
  const [step, setStep] = useState(0)

  const rotateWrappers = ()=>{
    const order = [
      'wallets-revolution-wrapper--1',
      'wallets-revolution-wrapper--2',
      'wallets-revolution-wrapper--3',
      'wallets-revolution-wrapper--4',
      'wallets-revolution-wrapper--5',
      'wallets-revolution-wrapper--6',
    ];

    const posToElem = order.map(cls => sceneRef.current.querySelector(`.${cls}`));
    
    // rotate by slicing: drop the first, append it to the end
    const newPosToElem = [...posToElem.slice(1), posToElem[0]];

    newPosToElem.forEach((el, idx) => {
      // remove all slot‐classes, then reassign based on idx
      el.classList.remove(...order);
      el.classList.add(order[idx]);
    });
  }

  useEffect(() => {
    const id = setInterval(() => {
      setStep((prev)=> {
        if(prev == 7) {
          rotateWrappers()
        }
        return (prev + 1) % 8
      }) // step 0 - 7
    }, 1000)

    return () => clearInterval(id)
  }, [])

  return (
    <div
      className={
        `position-relative wallets-revolution-scene ` +
        `wallets-revolution-scene-step--${step}`
      }
      ref={sceneRef}
    >

      <div className="wallets-revolution-wrapper wallets-revolution-wrapper--6">
        <div className="wallets-revolution-wallet d-flex flex-column rabby">
          <div className="wallets-revolution-wallet-logo"></div>

          <div className="wallets-revolution-payment-drawer rabby">
            <div className="wallets-revolution-payment-title">Payment</div>
            <div className="wallets-revolution-payment-payment">
              <div className="wallets-revolution-payment-token">
                <div className="wallets-revolution-payment-token-logo eth"></div>
                <div className="wallets-revolution-payment-blockchain ethereum"><div className="wallets-revolution-payment-blockchain-logo"></div></div>
              </div>
              <div className="wallets-revolution-payment-amounts">
                <div className="wallets-revolution-payment-amount-token">ETH 0.033</div>
                <div className="wallets-revolution-payment-amount-fiat">US$99.00</div>
              </div>
              
            </div>
            
            <div className="wallets-revolution-payment-confirming">
              <div className="ActionIndicator">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiBmaWxsPSIjMDA1MkZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUyIDUxMkMxNTIgNzEwLjgyMyAzMTMuMTc3IDg3MiA1MTIgODcyQzcxMC44MjMgODcyIDg3MiA3MTAuODIzIDg3MiA1MTJDODcyIDMxMy4xNzcgNzEwLjgyMyAxNTIgNTEyIDE1MkMzMTMuMTc3IDE1MiAxNTIgMzEzLjE3NyAxNTIgNTEyWk00MjAgMzk2QzQwNi43NDUgMzk2IDM5NiA0MDYuNzQ1IDM5NiA0MjBWNjA0QzM5NiA2MTcuMjU1IDQwNi43NDUgNjI4IDQyMCA2MjhINjA0QzYxNy4yNTUgNjI4IDYyOCA2MTcuMjU1IDYyOCA2MDRWNDIwQzYyOCA0MDYuNzQ1IDYxNy4yNTUgMzk2IDYwNCAzOTZINDIwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="></img>
                <div className="ActionIndicatorSpinner"></div>
              </div>
              <div className="text-center"><span className="FontSizeL">Confirm in your wallet</span></div>
            </div>

            <div className="wallets-revolution-payment-performing">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <div className="ActionIndicatorSpinner"></div>
                </div>
                <div className="StepText">
                  <div className="LoadingText">Performing payment<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></div>
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-confirmed">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <svg className="Checkmark Icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24">
                     <path d="M20,4.9L9.2,16l-5.4-3.9c-0.7-0.5-1.6-0.3-2.1,0.3c-0.5,0.7-0.3,1.6,0.3,2.1l6.4,4.7c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.8-0.2,1.1-0.5l11.7-12c0.6-0.6,0.6-1.6,0-2.2C21.6,4.3,20.6,4.3,20,4.9z"></path>
                  </svg>
                </div>
                <div className="StepText">
                  Payment confirmed
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-payment">Pay</div>
            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-done">Done</div>
          </div>
        </div>

        <div className="wallets-revolution-wallet-shadow-wrapper">
          <div className="wallets-revolution-wallet-shadow"></div>
        </div>
      </div>

      <div className="wallets-revolution-wrapper wallets-revolution-wrapper--5">
        <div className="wallets-revolution-wallet d-flex flex-column trust">
          <div className="wallets-revolution-wallet-logo"></div>

          <div className="px-3 ">
            <div className="pt-3">
              <div className="text-center pt-1 font-size-s line-height-extra-small">Main Wallet</div>
            </div>
          </div>

          <div className="wallets-revolution-payment-drawer dark trust">
            <div className="wallets-revolution-payment-title">Payment</div>
            
            <div className="wallets-revolution-payment-payment">
              <div className="wallets-revolution-payment-token">
                <div className="wallets-revolution-payment-token-logo eth"></div>
                <div className="wallets-revolution-payment-blockchain ethereum"><div className="wallets-revolution-payment-blockchain-logo"></div></div>
              </div>
              <div className="wallets-revolution-payment-amounts">
                <div className="wallets-revolution-payment-amount-token">ETH 0.033</div>
                <div className="wallets-revolution-payment-amount-fiat">US$99.00</div>
              </div>
              
            </div>
            
            <div className="wallets-revolution-payment-confirming">
              <div className="ActionIndicator">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiBmaWxsPSIjMDA1MkZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUyIDUxMkMxNTIgNzEwLjgyMyAzMTMuMTc3IDg3MiA1MTIgODcyQzcxMC44MjMgODcyIDg3MiA3MTAuODIzIDg3MiA1MTJDODcyIDMxMy4xNzcgNzEwLjgyMyAxNTIgNTEyIDE1MkMzMTMuMTc3IDE1MiAxNTIgMzEzLjE3NyAxNTIgNTEyWk00MjAgMzk2QzQwNi43NDUgMzk2IDM5NiA0MDYuNzQ1IDM5NiA0MjBWNjA0QzM5NiA2MTcuMjU1IDQwNi43NDUgNjI4IDQyMCA2MjhINjA0QzYxNy4yNTUgNjI4IDYyOCA2MTcuMjU1IDYyOCA2MDRWNDIwQzYyOCA0MDYuNzQ1IDYxNy4yNTUgMzk2IDYwNCAzOTZINDIwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="></img>
                <div className="ActionIndicatorSpinner"></div>
              </div>
              <div className="text-center"><span className="FontSizeL">Confirm in your wallet</span></div>
            </div>

            <div className="wallets-revolution-payment-performing">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <div className="ActionIndicatorSpinner"></div>
                </div>
                <div className="StepText">
                  <div className="LoadingText">Performing payment<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></div>
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-confirmed">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <svg className="Checkmark Icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24">
                     <path d="M20,4.9L9.2,16l-5.4-3.9c-0.7-0.5-1.6-0.3-2.1,0.3c-0.5,0.7-0.3,1.6,0.3,2.1l6.4,4.7c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.8-0.2,1.1-0.5l11.7-12c0.6-0.6,0.6-1.6,0-2.2C21.6,4.3,20.6,4.3,20,4.9z"></path>
                  </svg>
                </div>
                <div className="StepText">
                  Payment confirmed
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-payment">Pay</div>
            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-done">Done</div>
          </div>
          
        </div>
        <div className="wallets-revolution-wallet-shadow-wrapper">
          <div className="wallets-revolution-wallet-shadow"></div>
        </div>
      </div>

      <div className="wallets-revolution-wrapper wallets-revolution-wrapper--4">
        <div className="wallets-revolution-wallet d-flex flex-column phantom">
          <div className="wallets-revolution-wallet-logo"></div>

          <div className="px-3 ">
            <div className="pt-3 ps-3">
              <div className="text-left font-size-xs ps-4 opacity-50 line-height-extra-small">@toly</div>
              <div className="text-left font-size-s ps-4 line-height-extra-small">Account 1</div>
            </div>
          </div>

          <div className="wallets-revolution-payment-drawer dark phantom">
            <div className="wallets-revolution-payment-title">Payment</div>

            <div className="wallets-revolution-payment-payment">
              <div className="wallets-revolution-payment-token">
                <div className="wallets-revolution-payment-token-logo sol"></div>
                <div className="wallets-revolution-payment-blockchain solana"><div className="wallets-revolution-payment-blockchain-logo"></div></div>
              </div>
              <div className="wallets-revolution-payment-amounts">
                <div className="wallets-revolution-payment-amount-token">SOL 0.53</div>
                <div className="wallets-revolution-payment-amount-fiat">US$99.00</div>
              </div>
            </div>
            
            <div className="wallets-revolution-payment-confirming">
              <div className="ActionIndicator">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiBmaWxsPSIjMDA1MkZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUyIDUxMkMxNTIgNzEwLjgyMyAzMTMuMTc3IDg3MiA1MTIgODcyQzcxMC44MjMgODcyIDg3MiA3MTAuODIzIDg3MiA1MTJDODcyIDMxMy4xNzcgNzEwLjgyMyAxNTIgNTEyIDE1MkMzMTMuMTc3IDE1MiAxNTIgMzEzLjE3NyAxNTIgNTEyWk00MjAgMzk2QzQwNi43NDUgMzk2IDM5NiA0MDYuNzQ1IDM5NiA0MjBWNjA0QzM5NiA2MTcuMjU1IDQwNi43NDUgNjI4IDQyMCA2MjhINjA0QzYxNy4yNTUgNjI4IDYyOCA2MTcuMjU1IDYyOCA2MDRWNDIwQzYyOCA0MDYuNzQ1IDYxNy4yNTUgMzk2IDYwNCAzOTZINDIwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="></img>
                <div className="ActionIndicatorSpinner"></div>
              </div>
              <div className="text-center"><span className="FontSizeL">Confirm in your wallet</span></div>
            </div>

            <div className="wallets-revolution-payment-performing">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <div className="ActionIndicatorSpinner"></div>
                </div>
                <div className="StepText">
                  <div className="LoadingText">Performing payment<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></div>
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-confirmed">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <svg className="Checkmark Icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24">
                     <path d="M20,4.9L9.2,16l-5.4-3.9c-0.7-0.5-1.6-0.3-2.1,0.3c-0.5,0.7-0.3,1.6,0.3,2.1l6.4,4.7c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.8-0.2,1.1-0.5l11.7-12c0.6-0.6,0.6-1.6,0-2.2C21.6,4.3,20.6,4.3,20,4.9z"></path>
                  </svg>
                </div>
                <div className="StepText">
                  Payment confirmed
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-payment">Pay</div>
            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-done">Done</div>
          </div>
          
        </div>
        <div className="wallets-revolution-wallet-shadow-wrapper">
          <div className="wallets-revolution-wallet-shadow"></div>
        </div>
      </div>

      <div className="wallets-revolution-wrapper wallets-revolution-wrapper--3">

        <div className="wallets-revolution-wallet metamask">
          <div className="wallets-revolution-wallet-logo"></div>
          
          <div className="px-3 ">
            <div className="pt-3">
              <div className="text-center line-height-extra-small">Account 1</div>
            </div>
            <div>
              <div className="text-center opacity-50 font-size-s">0xd8dA6...96045</div>
            </div>
          </div>

          <div className="wallets-revolution-payment-drawer metamask">
            <div className="wallets-revolution-payment-title">Payment</div>
            
            <div className="wallets-revolution-payment-payment">
              <div className="wallets-revolution-payment-token">
                <div className="wallets-revolution-payment-token-logo eth"></div>
                <div className="wallets-revolution-payment-blockchain ethereum"><div className="wallets-revolution-payment-blockchain-logo"></div></div>
              </div>
              <div className="wallets-revolution-payment-amounts">
                <div className="wallets-revolution-payment-amount-token">ETH 0.033</div>
                <div className="wallets-revolution-payment-amount-fiat">US$99.00</div>
              </div>
            </div>
            
            <div className="wallets-revolution-payment-confirming">
              <div className="ActionIndicator">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiBmaWxsPSIjMDA1MkZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUyIDUxMkMxNTIgNzEwLjgyMyAzMTMuMTc3IDg3MiA1MTIgODcyQzcxMC44MjMgODcyIDg3MiA3MTAuODIzIDg3MiA1MTJDODcyIDMxMy4xNzcgNzEwLjgyMyAxNTIgNTEyIDE1MkMzMTMuMTc3IDE1MiAxNTIgMzEzLjE3NyAxNTIgNTEyWk00MjAgMzk2QzQwNi43NDUgMzk2IDM5NiA0MDYuNzQ1IDM5NiA0MjBWNjA0QzM5NiA2MTcuMjU1IDQwNi43NDUgNjI4IDQyMCA2MjhINjA0QzYxNy4yNTUgNjI4IDYyOCA2MTcuMjU1IDYyOCA2MDRWNDIwQzYyOCA0MDYuNzQ1IDYxNy4yNTUgMzk2IDYwNCAzOTZINDIwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="></img>
                <div className="ActionIndicatorSpinner"></div>
              </div>
              <div className="text-center"><span className="FontSizeL">Confirm in your wallet</span></div>
            </div>

            <div className="wallets-revolution-payment-performing">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <div className="ActionIndicatorSpinner"></div>
                </div>
                <div className="StepText">
                  <div className="LoadingText">Performing payment<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></div>
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-confirmed">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <svg className="Checkmark Icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24">
                     <path d="M20,4.9L9.2,16l-5.4-3.9c-0.7-0.5-1.6-0.3-2.1,0.3c-0.5,0.7-0.3,1.6,0.3,2.1l6.4,4.7c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.8-0.2,1.1-0.5l11.7-12c0.6-0.6,0.6-1.6,0-2.2C21.6,4.3,20.6,4.3,20,4.9z"></path>
                  </svg>
                </div>
                <div className="StepText">
                  Payment confirmed
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-payment">Pay</div>
            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-done">Done</div>
          </div>

        </div>
        <div className="wallets-revolution-wallet-shadow-wrapper">
          <div className="wallets-revolution-wallet-shadow"></div>
        </div>
      </div>

      <div className="wallets-revolution-wrapper wallets-revolution-wrapper--2">
        <div className="wallets-revolution-wallet d-flex flex-column binance">
          <div className="wallets-revolution-wallet-logo"></div>

          <div className="px-3 ">
            <div className="pt-3 ps-3">
              <div className="text-left font-size-s pt-2 ps-4 line-height-extra-small">Wallet1</div>
            </div>
          </div>

          <div className="wallets-revolution-payment-drawer dark binance">
            <div className="wallets-revolution-payment-title">Payment</div>
            
            <div className="wallets-revolution-payment-payment">
              <div className="wallets-revolution-payment-token">
                <div className="wallets-revolution-payment-token-logo bnb"></div>
                <div className="wallets-revolution-payment-blockchain bsc"><div className="wallets-revolution-payment-blockchain-logo"></div></div>
              </div>
              <div className="wallets-revolution-payment-amounts">
                <div className="wallets-revolution-payment-amount-token">BNB 0.142</div>
                <div className="wallets-revolution-payment-amount-fiat">US$99.00</div>
              </div>
              
            </div>
            
            <div className="wallets-revolution-payment-confirming">
              <div className="ActionIndicator">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiBmaWxsPSIjMDA1MkZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUyIDUxMkMxNTIgNzEwLjgyMyAzMTMuMTc3IDg3MiA1MTIgODcyQzcxMC44MjMgODcyIDg3MiA3MTAuODIzIDg3MiA1MTJDODcyIDMxMy4xNzcgNzEwLjgyMyAxNTIgNTEyIDE1MkMzMTMuMTc3IDE1MiAxNTIgMzEzLjE3NyAxNTIgNTEyWk00MjAgMzk2QzQwNi43NDUgMzk2IDM5NiA0MDYuNzQ1IDM5NiA0MjBWNjA0QzM5NiA2MTcuMjU1IDQwNi43NDUgNjI4IDQyMCA2MjhINjA0QzYxNy4yNTUgNjI4IDYyOCA2MTcuMjU1IDYyOCA2MDRWNDIwQzYyOCA0MDYuNzQ1IDYxNy4yNTUgMzk2IDYwNCAzOTZINDIwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="></img>
                <div className="ActionIndicatorSpinner"></div>
              </div>
              <div className="text-center"><span className="FontSizeL">Confirm in your wallet</span></div>
            </div>

            <div className="wallets-revolution-payment-performing">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <div className="ActionIndicatorSpinner"></div>
                </div>
                <div className="StepText">
                  <div className="LoadingText">Performing payment<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></div>
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-confirmed">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <svg className="Checkmark Icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24">
                     <path d="M20,4.9L9.2,16l-5.4-3.9c-0.7-0.5-1.6-0.3-2.1,0.3c-0.5,0.7-0.3,1.6,0.3,2.1l6.4,4.7c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.8-0.2,1.1-0.5l11.7-12c0.6-0.6,0.6-1.6,0-2.2C21.6,4.3,20.6,4.3,20,4.9z"></path>
                  </svg>
                </div>
                <div className="StepText">
                  Payment confirmed
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-payment">Pay</div>
            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-done">Done</div>
          </div>
          
        </div>
        <div className="wallets-revolution-wallet-shadow-wrapper">
          <div className="wallets-revolution-wallet-shadow"></div>
        </div>
      </div>

      <div className="wallets-revolution-wrapper wallets-revolution-wrapper--1">
        <div className="wallets-revolution-wallet d-flex flex-column coinbase">
          <div className="wallets-revolution-wallet-logo"></div>

          <div className="px-3 ">
            <div className="pt-3 ps-3">
              <div className="text-left font-size-s pt-2 ps-4">Address 1</div>
            </div>
          </div>

          <div className="wallets-revolution-payment-drawer base">
            <div className="wallets-revolution-payment-title">Payment</div>

            <div className="wallets-revolution-payment-payment">
              <div className="wallets-revolution-payment-token">
                <div className="wallets-revolution-payment-token-logo usdc"></div>
                <div className="wallets-revolution-payment-blockchain base"><div className="wallets-revolution-payment-blockchain-logo"></div></div>
              </div>
              <div className="wallets-revolution-payment-amounts">
                <div className="wallets-revolution-payment-amount-token">USDC 99.00</div>
                <div className="wallets-revolution-payment-amount-fiat">US$99.00</div>
              </div>
            </div>
            
            <div className="wallets-revolution-payment-confirming">
              <div className="ActionIndicator">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiBmaWxsPSIjMDA1MkZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUyIDUxMkMxNTIgNzEwLjgyMyAzMTMuMTc3IDg3MiA1MTIgODcyQzcxMC44MjMgODcyIDg3MiA3MTAuODIzIDg3MiA1MTJDODcyIDMxMy4xNzcgNzEwLjgyMyAxNTIgNTEyIDE1MkMzMTMuMTc3IDE1MiAxNTIgMzEzLjE3NyAxNTIgNTEyWk00MjAgMzk2QzQwNi43NDUgMzk2IDM5NiA0MDYuNzQ1IDM5NiA0MjBWNjA0QzM5NiA2MTcuMjU1IDQwNi43NDUgNjI4IDQyMCA2MjhINjA0QzYxNy4yNTUgNjI4IDYyOCA2MTcuMjU1IDYyOCA2MDRWNDIwQzYyOCA0MDYuNzQ1IDYxNy4yNTUgMzk2IDYwNCAzOTZINDIwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="></img>
                <div className="ActionIndicatorSpinner"></div>
              </div>
              <div className="text-center"><span className="FontSizeL">Confirm in your wallet</span></div>
            </div>

            <div className="wallets-revolution-payment-performing">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <div className="ActionIndicatorSpinner"></div>
                </div>
                <div className="StepText">
                  <div className="LoadingText">Performing payment<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></div>
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-confirmed">
              <div className="StepWrapper">
                <div className="StepIcon">
                  <svg className="Checkmark Icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24">
                     <path d="M20,4.9L9.2,16l-5.4-3.9c-0.7-0.5-1.6-0.3-2.1,0.3c-0.5,0.7-0.3,1.6,0.3,2.1l6.4,4.7c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.8-0.2,1.1-0.5l11.7-12c0.6-0.6,0.6-1.6,0-2.2C21.6,4.3,20.6,4.3,20,4.9z"></path>
                  </svg>
                </div>
                <div className="StepText">
                  Payment confirmed
                </div>
              </div>
            </div>

            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-payment">Pay</div>
            <div className="wallets-revolution-payment-button wallets-revolution-payment-button-done">Done</div>

          </div>

        </div>
        <div className="wallets-revolution-wallet-shadow-wrapper">
          <div className="wallets-revolution-wallet-shadow"></div>
        </div>
      </div>
    </div>
  )
}
